import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Analytics from 'react-ga';
import SimplePageTemplate from '../SimplePageTemplate';
import drumImage1 from './assets/pearl-drums-1.png';
import drumImage2 from './assets/pearl-drums-2.png';
import drumImage3 from './assets/pearl-drums-3.png';
import pearlBannerImage from './assets/pearl-banner.png';

const PEARL_WARRANTY_URL = 'http://pearldrum.com/support/warranty/';

export default class DrumsPage extends Component {

  componentDidMount() {

    Analytics.pageview('/drums');
  }

  render(){
    return (
      <SimplePageTemplate location={this.props.location}
                          bannerImage={pearlBannerImage}
                          bannerAlt="Save up to 40% off Pearl drum sets"
                          image1={drumImage1}
                          image2={drumImage2}
                          image3={drumImage3}
                          imageAlt="Pearl drums">
        <p>
          Now's the time to buy your first drum kit or upgrade from your old set, because
          we're taking up to 40% off our Pearl drum sets, including the popular Export
          and <Link to="/roadshow">Road Show series drums</Link>. Pearl has been a percussion pioneer for over 60 years
          and offers some of the industry's most rugged, advanced instruments. They also
          include <a target="_blank" href={PEARL_WARRANTY_URL}>the best warranty in the industry</a>,
          guaranteeing their shells and hardware for life.
          Don't miss out on your dream set - come in to see our drum selection today.
        </p>
      </SimplePageTemplate>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DrumsPage/index.js